import React, { useEffect, useRef } from 'react';
import { Calendar, MessageSquare, Monitor, Utensils, FileText, Heart } from 'lucide-react';
export function Features() {
  const sectionRef = useRef<HTMLElement>(null);
  const hasTracked = useRef(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasTracked.current) {
          try {
            if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
              window.fbq('trackCustom', 'ViewFeaturesSection', {
                section: 'Product Features'
              });
              console.log('✅ ViewFeaturesSection event tracked');
              hasTracked.current = true;
            }
          } catch (error) {
            console.error('❌ Error tracking features section:', error);
          }
        }
      });
    }, {
      threshold: 0.5
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-12 bg-white" id="contenido" data-id="element-83">
      <div className="container mx-auto px-4 md:px-6" data-id="element-84">
        <div className="max-w-4xl mx-auto" data-id="element-85">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-900 mb-8 font-serif text-center" data-id="element-86">
            Qué incluye "Cría con calma"
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-87">
            <div className="bg-amber-50 p-6 rounded-lg border border-amber-100" data-id="element-88">
              <div className="flex items-center gap-3 mb-3" data-id="element-89">
                <div className="h-12 w-12 bg-amber-700 rounded-full flex items-center justify-center" data-id="element-90">
                  <Calendar className="text-white" size={24} data-id="element-91" />
                </div>
                <h3 className="font-bold text-amber-900 text-lg" data-id="element-92">
                  Tableros de Rutina Imprimibles
                </h3>
              </div>
              <p className="text-amber-800 text-sm" data-id="element-93">
                Mañana y noche, con iconos claros para que el niño marque cada
                paso completado
              </p>
            </div>
            <div className="bg-amber-50 p-6 rounded-lg border border-amber-100" data-id="element-94">
              <div className="flex items-center gap-3 mb-3" data-id="element-95">
                <div className="h-12 w-12 bg-amber-700 rounded-full flex items-center justify-center" data-id="element-96">
                  <MessageSquare className="text-white" size={24} data-id="element-97" />
                </div>
                <h3 className="font-bold text-amber-900 text-lg" data-id="element-98">
                  Guiones de 3 Pasos
                </h3>
              </div>
              <p className="text-amber-800 text-sm" data-id="element-99">
                Para berrinches, transiciones y momentos difíciles (firmes y
                amables)
              </p>
            </div>
            <div className="bg-amber-50 p-6 rounded-lg border border-amber-100" data-id="element-100">
              <div className="flex items-center gap-3 mb-3" data-id="element-101">
                <div className="h-12 w-12 bg-amber-700 rounded-full flex items-center justify-center" data-id="element-102">
                  <Monitor className="text-white" size={24} data-id="element-103" />
                </div>
                <h3 className="font-bold text-amber-900 text-lg" data-id="element-104">
                  Contrato Familiar de Pantallas
                </h3>
              </div>
              <p className="text-amber-800 text-sm" data-id="element-105">
                Límites claros y consensuados para tablet, TV y móvil
              </p>
            </div>
            <div className="bg-amber-50 p-6 rounded-lg border border-amber-100" data-id="element-106">
              <div className="flex items-center gap-3 mb-3" data-id="element-107">
                <div className="h-12 w-12 bg-amber-700 rounded-full flex items-center justify-center" data-id="element-108">
                  <Utensils className="text-white" size={24} data-id="element-109" />
                </div>
                <h3 className="font-bold text-amber-900 text-lg" data-id="element-110">
                  Recetario Exprés
                </h3>
              </div>
              <p className="text-amber-800 text-sm" data-id="element-111">
                12 cenas en 15–20 minutos que los niños sí comen
              </p>
            </div>
            <div className="bg-amber-50 p-6 rounded-lg border border-amber-100" data-id="element-112">
              <div className="flex items-center gap-3 mb-3" data-id="element-113">
                <div className="h-12 w-12 bg-amber-700 rounded-full flex items-center justify-center" data-id="element-114">
                  <FileText className="text-white" size={24} data-id="element-115" />
                </div>
                <h3 className="font-bold text-amber-900 text-lg" data-id="element-116">
                  Guía de Implementación
                </h3>
              </div>
              <p className="text-amber-800 text-sm" data-id="element-117">
                Paso a paso para aplicar el sistema sin abrumar
              </p>
            </div>
            <div className="bg-amber-50 p-6 rounded-lg border border-amber-100" data-id="element-118">
              <div className="flex items-center gap-3 mb-3" data-id="element-119">
                <div className="h-12 w-12 bg-amber-700 rounded-full flex items-center justify-center" data-id="element-120">
                  <Heart className="text-white" size={24} data-id="element-121" />
                </div>
                <h3 className="font-bold text-amber-900 text-lg" data-id="element-122">
                  Tarjetas de Calma
                </h3>
              </div>
              <p className="text-amber-800 text-sm" data-id="element-123">
                Herramientas visuales para autorregulación emocional
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}